import { setError, setSuccessMessage } from '../App/ErrorsActions';
import * as BECaller from '../../util/apiCaller';
import _ from 'lodash';

export const LOADING = 'PORTFOLIO_SETTING_LOADING';
export const SUCCESS_PORTFOLIOS = 'VALUE_PORTFOLIOS_SUCCESS';
export const SUCCESS_DATA = 'PORTFOLIO_SUCCESS_DATA';
export const SELECT_PORTFOLIO = 'PORTFOLIOS_SELECT';
export const UPDATE_SELECTED_PORTFOLIO = 'PORTFOLIOS_UPDATE_SELECTED';
export const NO_PORTFOLIOS = 'NO_PORTFOLIOS';
export const SET_DATE_RANGE_LOADING = 'PORTFOLIO_SET_DATE_RANGE_LOADING';

const MAX_RETRIES = 3600;

export function handleError(err, opt) {
  return setError(err, opt);
}

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function successPortfolios(data) {
  return {
    type: SUCCESS_PORTFOLIOS,
    portfolios: data
  };
}

export function noPortfolios() {
  return {
    type: NO_PORTFOLIOS
  };
}

function successData(data) {
  return {
    type: SUCCESS_DATA,
    data
  };
}


export function selectPortfolio(portfolio, viewId) {
  return {
    type: SELECT_PORTFOLIO,
    selected: portfolio,
    viewId
  };
}

export function updateSelectedPortfolio(portfolio) {
  return {
    type: UPDATE_SELECTED_PORTFOLIO,
    selected: portfolio
  };
}

export function deletePortfolio(portfolioId) {
  return dispatch => {
    BECaller.api(`executive/portfolios/${portfolioId}`, 'delete').then(
      () => {
        dispatch(listAll());
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function saveSelected(id) {
  return dispatch => {
    BECaller.api(`executive/portfolios/selected`, 'put', {
      id
    }).then(
      () => {},
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function saveSelectedPortfolioBreakdown(id, chart, value) {
  return (dispatch, getState) => {
    BECaller.api(`executive/portfolios/selected/chart`, 'put', {
      id,
      chart,
      value
    }).then(
      (res) => {
        const portfolios = getState().portfolio.portfolios;
        const updatedPortfolios = portfolios.map(portfolio => {
          if (portfolio._id === res._id) {
            return { ...portfolio, [chart]: res[chart] };
          }
          return portfolio;
        });
        dispatch(successPortfolios(_.sortBy(updatedPortfolios, 'name')));

        const selectedPortfolio = getState().portfolio.selectedPortfolio;
        if (selectedPortfolio && selectedPortfolio._id === res._id) {
          dispatch(updateSelectedPortfolio({ ...selectedPortfolio, [chart]: res[chart] }));
        }
      },
      err => dispatch(handleError(err))
    );
  };
}

export function listAll() {
  return (dispatch, getState) => {
    return BECaller.api(`executive/portfolios/list`, 'get').then(
      data => {
        if (data.length) {
          let selected = getState().portfolio.selectedPortfolio;
          if (selected && selected._id) {
            let selectedPortfolio = _.find(data, b => b._id == selected._id);
            selectedPortfolio && dispatch(selectPortfolio({ ...selectedPortfolio }));
          }
          dispatch(successPortfolios(_.sortBy(data, 'name')));
          return data;
        } else {
          dispatch(noPortfolios());
          return [];
        }
      },
      err => {
        dispatch(handleError(err));
        throw err;
      }
    );
  };
}

export function savePortfolio(data) {
  return (dispatch, getState) => {
    dispatch(isLoading(true));
    return BECaller.api(`executive/portfolios`, 'post', data).then(
      res => {
        dispatch(isLoading(false));
        dispatch(setSuccessMessage('Settings updated successfully'));
        dispatch(selectPortfolio({ ...res }));

        let portfolios = getState().portfolio.portfolios;
        const index = portfolios.findIndex(s => s._id === res._id);

        if (index !== -1) {
          portfolios[index] = res;
        } else {
          portfolios.push(res);
        }

        dispatch(successPortfolios(_.sortBy(portfolios, 'name')));
        return res;
      },
      err => {
        dispatch(handleError(err));
        dispatch(isLoading(false));
        throw err;
      }
    );
  };
}

export function requestData(id) {
  const url = `executive/portfolios/${id}`;
  return (dispatch) => {
    if (!id) return;
    dispatch(isLoading(true));

    BECaller.api(url, 'get')
      .then(res => {
        dispatch(successData(res));
        dispatch(isLoading(false));
      })
      .catch(err => {
        dispatch(handleError(err));
        dispatch(isLoading(false));
      });
  };
}

export function setDateRangeLoading(isLoading) {
  return {
    type: SET_DATE_RANGE_LOADING,
    isLoading
  };
}

function pollJobStatus(jobId, streamId) {
  return BECaller.api(`executive/data/${jobId}/pullingstatus/${streamId}`, 'get');
}

function waitForJobs(triggeredJobs, maxRetries = MAX_RETRIES) {
  let retries = 0;
  let pollTimeoutId;
  const pendingJobs = new Set(triggeredJobs.map(j => j.jobId));

  return new Promise((resolve, reject) => {
    async function poll() {
      if (retries >= maxRetries) {
        reject(new Error('Calculation is taking longer than expected.'));
        return;
      }

      const checkPromises = triggeredJobs
        .filter(j => pendingJobs.has(j.jobId))
        .map(j =>
          pollJobStatus(j.jobId, j.streamId)
            .then(res => ({ ...res, jobId: j.jobId, streamId: j.streamId }))
            .catch(() => ({ failed: true, jobId: j.jobId, streamId: j.streamId }))
        );

      try {
        const results = await Promise.all(checkPromises);
        let hasFailure = false;

        results.forEach(res => {
          if (res.completed || res.noJob) {
            pendingJobs.delete(res.jobId);
          } else if (res.failed) {
            pendingJobs.delete(res.jobId);
            hasFailure = true;
          }
        });

        if (hasFailure) {
          reject(new Error('Some calculations failed. Please try again later.'));
          return;
        }

        if (pendingJobs.size === 0) {
          resolve();
          return;
        }

        retries++;
        pollTimeoutId = setTimeout(poll, 2000);
      } catch (err) {
        reject(err);
      }
    }

    poll();
  });
}

export function updateDateRange(portfolioId, displayDateRangeFrom, displayDateRangeTo) {
  return (dispatch, getState) => {
    dispatch(isLoading(true));

    return BECaller.api(`executive/portfolios/${portfolioId}/daterange`, 'put', {
      displayDateRangeFrom,
      displayDateRangeTo
    }).then(
      async res => {
        const selectedPortfolio = getState().portfolio.selectedPortfolio;
        if (selectedPortfolio && selectedPortfolio._id === portfolioId) {
          dispatch(selectPortfolio({
            ...selectedPortfolio,
            displayDateRangeFrom: res.displayDateRangeFrom,
            displayDateRangeTo: res.displayDateRangeTo
          }));
        }

        const portfolios = getState().portfolio.portfolios;
        const updatedPortfolios = portfolios.map(portfolio => {
          if (portfolio._id === portfolioId) {
            return {
              ...portfolio,
              displayDateRangeFrom: res.displayDateRangeFrom,
              displayDateRangeTo: res.displayDateRangeTo
            };
          }
          return portfolio;
        });
        dispatch(successPortfolios(_.sortBy(updatedPortfolios, 'name')));

        if (res.recalculationTriggered && res.triggeredJobs && res.triggeredJobs.length > 0) {
          dispatch(isLoading(true));
          dispatch(setSuccessMessage(res.message));

          try {
            await waitForJobs(res.triggeredJobs);
            dispatch(requestData(portfolioId));
          } catch (err) {
            dispatch(isLoading(false));
            dispatch(handleError({ message: err.message }));
          }
        } else {
          dispatch(requestData(portfolioId));
        }

        return res;
      },
      err => {
        dispatch(isLoading(false));
        const errorToDispatch = err || { message: 'Failed to update date range. Please try again.' };
        dispatch(handleError(errorToDispatch));
        throw err;
      }
    );
  };
}
